
import { Vue, Component, Prop } from 'vue-property-decorator'
import { applicationRules } from '@/utils/rules'
import {
  getApplicationListInfo,
  modifyApplication
} from '@/api/enterpriseApp/enterpriseApp'
import { Form as ElForm } from 'element-ui'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'editApplication',
  props: {
    id: {
      type: Number
    },
    enterpriseType: {
      type: String
    }
  }
})
export default class extends Vue {
  @Prop({ required: true }) private availableCurrency!: any
  @Prop({ required: true }) private antCurrency!: any
  private infoForm: any = {
    name: '',
    status: null,
    available_currency: [],
    can_active: null,
    enterprise_type: ''
  }
  private status: any = ''
  private rules = applicationRules
  private loading = false

  // 获取应用信息
  async getApplicationListInfo() {
    try {
      this.loading = true
      let data: any = {
        id: this.$props.id,
        enterprise_type: this.$props.enterpriseType
      }
      await getApplicationListInfo(data).then((res: any) => {
        // this.infoForm = Object.assign(this.infoForm, res)
        this.infoForm = res
        this.loading = false
      })
    } catch (e) {
      this.loading = false
    }
  }

  private back() {
    this.$emit('close', false)
  }

  private async update() {
    (this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          const data: any = {
            ...this.infoForm,
            status: this.status
          }
          delObjEmptyKey(data)
          await modifyApplication(data).then(() => {
            this.$message({
              message: 'Edit success',
              type: 'success'
            })
            this.back()
            this.loading = false
          })
        } catch (e) {
          this.back()
          this.loading = false
        }
      } else {
        return false
      }
    })
  }
  mounted() {
    this.getApplicationListInfo()
  }
}
